import type { TypedUseSelectorHook } from 'react-redux';
import { useSelector } from 'react-redux';
import type { AnyAction } from 'redux';
import { combineReducers } from 'redux';
import type { Reducer } from 'typesafe-actions';
import { default as admin, initialState as initialAdminState } from './admin/reducer';
import { default as authentication, initialState as initialAuthenticationTokensState } from './authentication/reducer';
import { AuthenticationActionTypes } from './authentication/types';
import { default as customer, initialCustomerState } from './customer/reducer';
import { default as encoders, initialState as initialEncodersState } from './encoders/reducer';
import { default as regions, initialState as initialRegionsState } from './regions/reducer';

const appReducer = combineReducers({
  admin,
  authentication,
  customer,
  encoders,
  regions,
});

export type RootState = ReturnType<typeof appReducer>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;

export const initialRootState: RootState = {
  admin: initialAdminState,
  authentication: initialAuthenticationTokensState,
  customer: initialCustomerState,
  encoders: initialEncodersState,
  regions: initialRegionsState,
};

const rootReducer: Reducer<RootState, AnyAction> = (state, action) => {
  if (
    action.type === AuthenticationActionTypes.LOGOUT_REQUEST_SUCCESS &&
    !state?.authentication.expired &&
    !state?.authentication.isVenue
  ) {
    state = undefined;
  } else if (action.type === AuthenticationActionTypes.SWITCHED_ORGS && state) {
    // Reset all state objects back to initial state.
    // EXCEPT for [adminSearch, authentication, customer, regions]
    state.admin = initialAdminState;
    state.encoders = initialEncodersState;
  }

  return appReducer(state, action);
};

export default rootReducer;
